module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABVCAYAAACBzexXAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAALxJREFUeJzt3LFtA0EQBME5QsHQYLoElK0UxBtndFUEY7S7e7b9jazX7QHcJYA4AcQJIE4AcQKIE0CcAOIEECeAOAHECSBOAHFn2/v2CAAAAAAAAAAAAACeOdt+b4/gnjM/gtLcBcQJIE4AcQKIE0CcAOIEECeAOAHECSBOAHECiPvZ9r09AgAAAAAAAAAAAIBnzrbP7RHc40VMnLuAOAHECSBOAHECiBNAnADiBBAngDgBxAkgTgBxAoj7B6DuBNUQoEX9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icon.png
// module id = 863
// module chunks = 114276838955818